import React, { useEffect } from 'react'
import { BtnV2, Link, l } from '@manychat/manyui'

import { UpgradeSource, useBilling } from 'common/billing'
import { useRetryPayment } from 'common/billing/hooks/useRetryPayment'
import { analyticsService } from 'utils/services/analytics'

import cm from '../StaticNotifications.module.css'

export const PayNowNotification = () => {
  const { handleRetryPayment, isLoading } = useRetryPayment('NOTIFICATION_BAR')

  const { billing } = useBilling()

  const handleUpdatePaymentMethod = () => {
    analyticsService.sendEvent('NOTIFICATION_BAR.UPDATE_PAYMENT_METHOD.CLICK')
    billing.updateCredentials({
      source: UpgradeSource.SETTINGS_UPDATE_PAYMENT_METHOD,
    })
  }

  useEffect(() => {
    analyticsService.sendEvent('NOTIFICATION_BAR.PAY_NOW.SHOWN')
  }, [])

  const text = l.translate(
    'We couldn’t process your latest payment, some automations may stop running.',
  )

  return (
    <>
      <span>{text}</span>
      <BtnV2 variant="primary" className="m-x-xs" loading={isLoading} onClick={handleRetryPayment}>
        {l.translate('Retry payment')}
      </BtnV2>
      <Link target="_blank" className={cm.more} onClick={handleUpdatePaymentMethod}>
        {l.translate('Change payment method')}
      </Link>
    </>
  )
}
